export default __webpack_public_path__ + "static/media/logo-algori.381035d9.svg";